export default {
  type: "form-text",
  style: "",
  data: {
    label: "New Text Field",
    placeholder: "Please Enter",
    maxlength: 10000,
    minlength: 0,
  },
  children: [],
};
